import {faAddressBook} from "@fortawesome/pro-solid-svg-icons/faAddressBook";
import {faBriefcase} from "@fortawesome/pro-solid-svg-icons/faBriefcase";
import {faTag} from "@fortawesome/pro-solid-svg-icons/faTag";
import {faUser} from "@fortawesome/pro-solid-svg-icons/faUser";
import {ColourSolid} from "@twigsby/frontend-framework";
import AddressBook from "../../Pages/User/Account/AddressBook";
import BusinessDetails from "../../Pages/User/Account/BusinessDetails";
import PersonalDetails from "../../Pages/User/Account/PersonalDetails";
import Tags from "../../Pages/User/Account/Tags";
import {SuggestibleRouteInterface} from "../TopRoutes";

const AccountRoutes: Array<SuggestibleRouteInterface> = [
    {
        title: 'Personal Details',
        path: '/manage-account/personal-details',
        icon: faUser,
        element: <PersonalDetails />,
        colour: ColourSolid.Primary,
        group: 'Your User'
    },
    {
        title: 'Business Details',
        path: '/manage-account/business-details',
        icon: faBriefcase,
        element: <BusinessDetails />,
        colour: ColourSolid.Primary,
        group: 'Your User'
    },
    {
        title: 'Address Book',
        path: '/manage-account/address-book',
        icon: faAddressBook,
        element: <AddressBook/>,
        colour: ColourSolid.Primary,
        group: 'Your User'
    },
    {
        title: 'Tags',
        path: '/manage-account/tags',
        icon: faTag,
        element: <Tags />,
        colour: ColourSolid.Primary,
        group: 'Your User'
    },
]

export { AccountRoutes }
